import  { FirstContactAttachmentFormValues,  type IFirstContactAttachmentEnvelope} from "models/FirstContactAttachment/FirstContactAttachment";
import {api} from './apiBase.service'

const FirstContactAttachment = {
    list: (params: URLSearchParams): Promise<IFirstContactAttachmentEnvelope> => api.get   ( `/FirstContact/Attachment`, {params: params}),
    listById: (FirstContactId: string, params: URLSearchParams): Promise<IFirstContactAttachmentEnvelope> => api.get   ( `/FirstContact/${FirstContactId}/Attachment`, {params: params}),
    create: (attachment: FirstContactAttachmentFormValues) => {
        let formData = new FormData();
        for (const key in attachment) {
            formData.append(key, attachment[key])
        }
        return api.post(`/FirstContact/Attachment`, formData)
    },
    delete: (id: string) => api.del   ( `/FirstContact/Attachment/${id}`),
    byId: (id: string) => api.get   ( `/FirstContact/Attachment/${id}`),
};


export default FirstContactAttachment
